export default "__VITE_ASSET__0140f26f__"